import React from 'react';
import { dateDifference } from '../../../../utils';
import { ILineInTimeline } from '../../../../Types';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import theme from '../../../../themes/CBB/theme';

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: '100%',
    position: 'relative',
    height: theme.spacing(1),
  },
  lineDuration: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(1),
    borderRadius: 64,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderColor: theme.palette.brand.greyLight,
    borderWidth: theme.spacing(0.25),
    borderStyle: 'solid',
    backgroundColor: 'transparent',
  },
  progressWrapper: {
    width: '100%',
    height: theme.spacing(0.75),
    backgroundColor: theme.palette.brand.greyLight,
    position: 'absolute',
    top: 1,
  },
  timelineEdgeBackground: {
    width: theme.spacing(1.25),
    height: theme.spacing(1),
    backgroundColor: theme.palette.brand.white,
    position: 'absolute',
    top: 0,
  },
  stickToRight: {
    right: 0,
  },
  stickToLeft: {
    left: 0,
  },
  lineProgress: {
    height: '100%',
    width: ({ lineProgress }: any) => {
      return lineProgress + '%';
    },
    opacity: 0.5,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.brand.green,
  },
}));

function getLineProgress(line: ILineInTimeline) {
  const isStagesInTimeline = line.stages.length > 0;
  if (!isStagesInTimeline) return;
  const startOfLine = line.visibleStartDate;
  const endOfLine = line.visibleEndDate;
  const totalDaysInLine = dateDifference(startOfLine, endOfLine);
  const currentDate = moment.utc();
  if (currentDate < startOfLine) {
    // LINE NOT STARTED
    return 0;
  } else if (currentDate > endOfLine) {
    // LINE COMPLETE
    return 100;
  } else {
    // IN MIDDLE OF LINE
    const daysSinceStartOfLine = moment(currentDate).diff(
      moment(startOfLine),
      'days',
    );
    const lineProgress = (daysSinceStartOfLine / totalDaysInLine) * 100;
    return lineProgress;
  }
}

interface LineProgressProps {
  line: ILineInTimeline;
  onboarding: boolean;
}

export default function LineProgress({ line, onboarding }: LineProgressProps) {
  const lineProgress = getLineProgress(line);
  const classes = useStyles({ lineProgress });

  return (
    <div className={classes.root}>
      <div className={classes.progressWrapper}>
        {!onboarding && <div className={classes.lineProgress} />}
      </div>
      <div
        className={`${classes.timelineEdgeBackground} ${classes.stickToLeft}`}
      ></div>
      <div
        className={`${classes.timelineEdgeBackground} ${classes.stickToRight}`}
      ></div>
      <div
        className={classes.lineDuration}
        style={{
          width: `calc(100% - ${theme.spacing(2)}px)`,
        }}
      ></div>
    </div>
  );
}
